export const OS_WORK_ORDER_CATALOG = [{ key: 'OS', label: 'OS', fileName: 'OS.pdf' }];

export function shouldShowOsWorkOrderButton({ scheduleType, page } = {}) {
  return !scheduleType && page !== 'ScheduleTrainingCenter';
}
